const undoTypes = {
  UNDO: 'UNDO',
  REDO: 'REDO',
  RESET: 'RESET',
  SET_REGISTERS: 'SET_REGISTERS'
}

export default undoTypes
